module.exports = __webpack_public_path__ + "img/stockout_lost_revenue_analysis.e2e61ade.svg";